const Remove01Icon = /*#__PURE__*/ [
  ["path", { d: "M19.002 12L5.00001 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { Remove01Icon as default };
//# sourceMappingURL=Remove01Icon.js.map
